import { withSentryErrorBoundary } from '@wix/native-components-infra/dist/src/HOC/sentryErrorBoundary/sentryErrorBoundary';
import React from 'react';
import { LIB_VERSION } from '../../../version';
import { useApi } from '../../context/api-context/use-api';
import { SENTRY_CONFIG_APP } from './sentry-error-boundary-config';
// Wrapper around withSentryErrorBoundary configured for this app and available to use anywhere in the tree
const withErrorBoundary = (Component, Fallback) => {
    const WrappedComponent = withSentryErrorBoundary(Component, SENTRY_CONFIG_APP, Fallback);
    return ((props) => {
        return (React.createElement(WrappedComponent, { ...useApi((_s, _a, host, ctx) => ({
                host,
                ravenUserContextOverride: ctx.ravenUserContextOverride,
            })), sentryRelease: LIB_VERSION, ...props }));
    });
};
export default withErrorBoundary;
//# sourceMappingURL=with-error-boundary.js.map